<template>
  <div>
    <v-btn color="primary" large @click="newUser">
      {{ $t('NEW TEMPLATE') }}
    </v-btn>
  </div>
</template>
<script>
export default {
  components: {},
  data: () => ({}),
  methods: {
    async newUser() {
      let me = this
      await me.$store.commit('templates/newTemplateToEditor', me.$store.state)
      await me.$store.commit('templates/set', [
        'editor.organisation',
        me.$route.params.organisationId
      ])
      await me.$redirect({
        name: 'template-creator'
      })
    }
  }
}
</script>
